"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// =======
// ACTIONS
// =======
const constants_1 = require("../constants");
// ===============
// ACTION CREATORS
// ===============
// None
// =======
// REDUCER
// =======
// Even though this is essentially a derived state, there are
// cases where deriving it from the rex forms state using reselect
// would cause entire forms to re-render. So, we're tracking formIds
// here.
const formIds = (state = [], action) => {
    switch (action.type) {
        case constants_1.LOAD_NEW_FORMS: {
            const { id } = action;
            return state.includes(id) ? state : [action.id, ...state];
        }
        case 'FormModel/LOAD_FORM': {
            const id = action.payload.modelKey;
            return state.includes(id) ? state : [id, ...state];
        }
        case constants_1.REMOVE_FORM: {
            return state.filter((id) => id !== action.id);
        }
        default:
            return state;
    }
};
exports.default = formIds;
//# sourceMappingURL=form-ids.js.map